<div class="flex justify-between mb-4">
  <div class="text-xl text-gray-700 font-bold">Agendamento de Frota</div>
</div>

<mat-tab-group animationDuration="200ms">
  <mat-tab label="Escala">
    <div class="mt-4">
      <app-schedule-search (response)="listSearch($event)"></app-schedule-search>
    </div>

    <div class="flex justify-end mt-4">
      <button mat-flat-button class="btn-tg" [disabled]="exportingExcel || loading || itemsList.length == 0"
        (click)="exportExcel()">
        @if (exportingExcel) {
        <mat-spinner diameter="20" class="loading-spinner"></mat-spinner>
        } @else {
        Exportar Excel
        }
      </button>
    </div>

    <div>
      <div class="mt-4">
        <div>
          @if (!loading) {
          @if (itemsList.length > 0) {
          <div class="tab-overflow overflow-auto w-[100%]">
            <table-list-schedule-fleet [dataSource]="itemsList" [columns]="columns" (selectItem)="editItem($event)"
              (viewItem)="viewItem($event)" (sendToPurchases)="sendToPurchasesItem($event)"
              (sortChange)="onSort($event)" sticky />
          </div>

          } @else {
          <div>
            <h3 class="text-center">Nenhum registro encontrado.</h3>
          </div>
          }
          } @else {
          <div>
            <mat-progress-bar mode="indeterminate"></mat-progress-bar>
          </div>
          }
          <mat-paginator [hidden]="itemsList.length == 0 || loading" [length]="numberRows" [pageSize]="rows"
            [pageIndex]="page - 1" [pageSizeOptions]="[5, 10, 20, 30]" (page)="onPageEvent($event)">
          </mat-paginator>
        </div>
      </div>
    </div>
  </mat-tab>

  <mat-tab label="Pré-escala">
    <pre-escala-frota class="block mt-4" />
  </mat-tab>

  <mat-tab label="Impedimentos">
    <impedimentos-motorista class="block mt-4" />
  </mat-tab>

  <mat-tab label="Cronograma do motorista">
    <cronograma-motorista class="block mt-4" />
  </mat-tab>
</mat-tab-group>